import { createI18n } from 'vue-i18n'
import zh from './zh.js'
import en from './en.js'

// Render the language of the URL. Geographic preference changes the URL before mount.
function getDefaultLocale() {
  const path = typeof window === 'undefined' ? '/' : window.location.pathname
  return path === '/zh' || path.startsWith('/zh/') ? 'zh' : 'en'
}

const i18n = createI18n({
  legacy: false, // use Composition API mode
  locale: getDefaultLocale(),
  fallbackLocale: 'en', // changed from 'zh' to 'en'
  messages: {
    zh,
    en
  }
})

export default i18n